<template>
  <v-dialog
    :value="open"
    content-class="addUser_dialog"
    @click:outside="handleOutside"
  >
    <v-btn
      icon
      class="addUser_dialog-closeIcon"
      tabindex="-1"
      @click="$emit('onClose')"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="addUser_dialog-title">
        <h1>{{ title }}</h1>
      </v-card-title>
      <v-divider />
      <v-card-text class="addUser_dialog-text">
        <v-container class="addUser_dialog-container">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h3>ID（メールアドレス）</h3>
              <v-text-field
                v-model="inputValue"
                hide-details
                height="40px"
                outlined
                :maxlength="80"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h3>権限</h3>
              <v-select
                v-model="selectedAuthority"
                hide-details
                :items="authorityItems"
                item-value="value"
                item-text="text"
                outlined
                flat
                append-icon="mdi-chevron-down"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions class="addUser_dialog-actions">
        <v-btn
          class="addUser_dialog-btn addUser_dialog-cancel"
          color="text"
          @click="handleClose"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="addUser_dialog-btn addUser_dialog-ok"
          color="primary"
          :disabled="!inputValue.trim()"
          :loading="loading"
          @click="handleOk"
        >
          {{ okLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AddUserDialog',
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => null,
    },
    okLabel: {
      type: String,
      default: () => '変更',
    },
  },
  data() {
    return {
      inputValue: '',
      selectedAuthority: 1,
    };
  },
  computed: {
    ...mapGetters('common', {
      isPRD: 'isPRD',
    }),
    authorityItems() {
      let items = [{ value: 1, text: 'カメラの操作可能' }];
      if (!this.isPRD) {
        items = [{ value: 0, text: 'LIVE映像のみ閲覧可能' }, ...items];
      }
      return items.sort((a, b) => b.value - a.value);
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.inputValue = '';
      }
    },
  },
  created() {
    this.inputValue = '';
  },
  methods: {
    handleOutside(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('onClose');
    },
    handleClose() {
      this.$emit('onClose');
    },
    async handleOk() {
      this.$emit('onOk', {
        authority: this.selectedAuthority,
        email: this.inputValue,
      });
    },
  },
};
</script>

<style lang="scss">
.addUser {
  .v-btn {
    margin-top: 10px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  .v-dialog > .v-card > .v-card__title {
    padding: 0;
  }
  &_dialog {
    position: relative;
    border-radius: 10px;
    width: 395px;
    overflow-y: unset;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    .v-card {
      border-radius: 10px;
    }
    h3 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-bottom: 10px;
    }
    &-cancel {
      color: #666 !important;
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-closeIcon {
      &.v-btn {
        &.v-btn--icon.v-size--default {
          position: absolute;
          right: 3px;
          top: 3px;
          z-index: 1;
        }

        .v-icon {
          margin-right: 0;
          font-size: 20px;
          color: #999;
          font-weight: bold;
        }

        &:not(.v-btn--text):not(.v-btn--outlined):hover:before,
        &.theme--light:hover::before {
          opacity: 0;
        }
      }
    }
    &-container {
      padding: 0 !important;
      .v-divider {
        border-color: #ccc;
      }
      & .v-input__append-inner {
        margin-top: 12px;
      }
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
    &-actions {
      margin-top: 20px;
      &.v-card__actions {
        padding: 8px 0 !important;
      }
      .v-btn {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      }
    }
    &-text {
      padding: 0 !important;
      margin-top: 9px;
      .v-text-field .v-input__control .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
      }
    }
    &-title {
      margin-bottom: 20px;
      h1 {
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
      &.v-card__title {
        padding: 0 !important;
      }
    }
  }
}
</style>
